export const ENVIRONMENT: string = process.env.REACT_APP_ENVIRONMENT ?? "prod";
